import React from "react";

import { Modal as AntModal, ModalProps as AntModalProps } from "antd";

import { trackMixpanel } from "utils";

import { Icon, PageSpin, Tooltip } from "components";

export type FullScreenOverlayProps = AntModalProps & {
  dataTestId?: string;
  loading?: boolean;
  showModal?: boolean;
  textColour?: string;
  onClose?: () => void;
  headerChildren?: React.ReactNode;
  children?: React.ReactNode;
  closeIconTooltip?: string;
};

export const FullScreenOverlay = ({
  children,
  dataTestId,
  loading,
  showModal,
  headerChildren,
  closeIconTooltip,
  onClose = () => {},
  ...props
}: FullScreenOverlayProps) => {
  const beforeClose = () => {
    trackMixpanel("CloseFullScreenOverlay", { overlay: dataTestId || "undefined" });
    onClose();
  };

  const closeIcon = closeIconTooltip ? (
    <Tooltip title={closeIconTooltip} placement="left">
      <Icon iconName="tabler/x" onClick={beforeClose} />
    </Tooltip>
  ) : (
    <Icon iconName="tabler/x" onClick={beforeClose} />
  );

  return (
    <AntModal
      data-testid={dataTestId}
      wrapClassName="full-screen-overlay"
      centered
      open={showModal}
      maskClosable={false}
      closeIcon={false}
      footer={null}
      destroyOnHidden={true}
      {...props}
    >
      <div className="icon-header">
        {headerChildren}
        {closeIcon}
      </div>
      {loading ? <PageSpin fullHeight={false} /> : children}
    </AntModal>
  );
};
